<template>
  <v-dialog
    v-if="programacion && derivaciones.length > 0"
    v-model="active"
    width="80%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Reagendar citas
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="derivaciones[2].oficioSolicitud"
                label="Oficio solicitud médico"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
              />
              <v-text-field
                label="Médica"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
                :value="fechaEvaluacionMedica"
                readonly
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="derivaciones[0].oficioSolicitud"
                label="Oficio solicitud psicológica"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
              />
              <v-text-field
                label="Psicológica"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
                :value="fechaEvaluacionPsicologica"
                readonly
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="derivaciones[5].oficioSolicitud"
                label="Oficio solicitud SITE"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
              />
              <v-text-field
                label="SITE"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
                :value="fechaEvaluacionSite"
                readonly
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="derivaciones[3].oficioSolicitud"
                label="Oficio solicitud ISE"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
              />
              <v-text-field
                label="ISE"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
                :value="fechaEvaluacionIse"
                readonly
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="derivaciones[1].oficioSolicitud"
                label="Oficio solicitud polígrafo"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
              />
              <v-text-field
                label="Polígrafo"
                rounded
                dense
                filled
                color="secondary"
                background-color="primary"
                :value="fechaEvaluacionPoligrafica"
                readonly
              />
            </v-col>
          </v-row>
          <v-form
            ref="form"
            v-model="form"
          >
            <v-row>
              <v-col>
                <v-datetime-picker
                  v-model="nuevaFechaEvaluacionMedica"
                  label="Reprogramar fecha"
                  :date-picker-props="datePickerProps"
                  :time-picker-props="timePickerProps"
                  :text-field-props="textFieldProps"
                  ok-text="Guardar"
                  clear-text="Cancelar"
                >
                  <template #dateIcon>
                    <v-icon color="secondary">
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template #timeIcon>
                    <v-icon color="secondary">
                      mdi-clock
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
              <v-col>
                <v-datetime-picker
                  v-model="nuevaFechaEvaluacionPsicologica"
                  label="Reprogramar fecha"
                  :date-picker-props="datePickerProps"
                  :time-picker-props="timePickerProps"
                  :text-field-props="textFieldProps"
                  ok-text="Guardar"
                  clear-text="Cancelar"
                >
                  <template #dateIcon>
                    <v-icon color="secondary">
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template #timeIcon>
                    <v-icon color="secondary">
                      mdi-clock
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
              <v-col>
                <v-datetime-picker
                  v-model="nuevaFechaEvaluacionSite"
                  label="Reprogramar fecha"
                  :date-picker-props="datePickerProps"
                  :time-picker-props="timePickerProps"
                  :text-field-props="textFieldProps"
                  ok-text="Guardar"
                  clear-text="Cancelar"
                >
                  <template #dateIcon>
                    <v-icon color="secondary">
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template #timeIcon>
                    <v-icon color="secondary">
                      mdi-clock
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
              <v-col>
                <v-datetime-picker
                  v-model="nuevaFechaEvaluacionIse"
                  label="Reprogramar fecha"
                  :date-picker-props="datePickerProps"
                  :time-picker-props="timePickerProps"
                  :text-field-props="textFieldProps"
                  ok-text="Guardar"
                  clear-text="Cancelar"
                >
                  <template #dateIcon>
                    <v-icon color="secondary">
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template #timeIcon>
                    <v-icon color="secondary">
                      mdi-clock
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
              <v-col>
                <v-datetime-picker
                  v-model="nuevaFechaEvaluacionPoligrafica"
                  label="Reprogramar fecha"
                  :date-picker-props="datePickerProps"
                  :time-picker-props="timePickerProps"
                  :text-field-props="textFieldProps"
                  ok-text="Guardar"
                  clear-text="Cancelar"
                >
                  <template #dateIcon>
                    <v-icon color="secondary">
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template #timeIcon>
                    <v-icon color="secondary">
                      mdi-clock
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          text
          color="secondary"
          @click="closeDialog()"
        >
          Cerrar
        </v-btn>
        <v-btn
          rounded
          color="secondary"
          :disabled="loading"
          :loading="loading"
          @click="triggerUpdateProgramacion()"
        >
          Guardar cambios
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    programacion: {
      type: Object,
      default: () => ({
        oficioSolicitud: '',
      }),
    },
  },

  data() {
    return {
      loading: false,
      form: false,

      evaluacionesTabs: 0,

      nuevaFechaEvaluacionMedica: null,
      nuevaFechaEvaluacionToxicologica: null,
      nuevaFechaEvaluacionPsicologica: null,
      nuevaFechaEvaluacionSite: null,
      nuevaFechaEvaluacionIse: null,
      nuevaFechaEvaluacionPoligrafica: null,

      datePickerProps: {
        color: 'secondary',
      },

      timePickerProps: {
        color: 'secondary',
        scrollable: true,
        format: '24hr',
      },

      textFieldProps: {
        rounded: true,
        filled: true,
        dense: true,
        color: 'secondary',
        backgroundColor: 'primary',
      },

      // Rules
      required: [(v) => !!v || 'Este campo es requerido.'],
      horaRules: [(v) => (v >= 0 && v <= 23) || 'Verifique este campo.'],
      minutoRules: [(v) => (v >= 0 && v <= 59) || 'Verifique este campo.'],
    };
  },

  computed: {
    fechaEvaluacionMedica() {
      return moment(this.programacion.fechaEvaluacionMedica).format('DD-MM-YYYY HH:mm');
    },

    fechaEvaluacionToxicologica() {
      return moment(this.programacion.fechaEvaluacionToxicologica).format('DD-MM-YYYY HH:mm');
    },

    fechaEvaluacionPsicologica() {
      return moment(this.programacion.fechaEvaluacionPsicologica).format('DD-MM-YYYY HH:mm');
    },

    fechaEvaluacionSite() {
      return moment(this.programacion.fechaRegistroSite).format('DD-MM-YYYY HH:mm');
    },

    fechaEvaluacionIse() {
      return moment(this.programacion.fechaEntrevistaIse).format('DD-MM-YYYY HH:mm');
    },

    fechaEvaluacionPoligrafica() {
      return moment(this.programacion.fechaEvaluacionPoligrafica).format('DD-MM-YYYY HH:mm');
    },

    ...mapGetters('motivoEvaluacion', {
      motivoEvaluacion: 'getMotivoEvaluacion',
    }),

    ...mapGetters('estatusProgramacion', {
      estatusProgramacion: 'getEstatusProgramacion',
    }),

    ...mapGetters('derivaciones', {
      derivaciones: 'getDerivaciones',
    }),
  },

  methods: {
    ...mapActions('programacionEvaluacion', ['updateProgramacionEvaluacion', 'fetchProgramacionesEvaluaciones']),
    ...mapActions('derivaciones', ['updateDerivacion']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    closeDialog() {
      this.nuevaFechaEvaluacionMedica = null;
      this.nuevaFechaEvaluacionToxicologica = null;
      this.nuevaFechaEvaluacionPsicologica = null;
      this.nuevaFechaEvaluacionSite = null;
      this.nuevaFechaEvaluacionIse = null;
      this.nuevaFechaEvaluacionPoligrafica = null;
      this.$refs.form.reset();
      this.loading = false;
      this.$emit('close');
    },

    async triggerUpdateProgramacion() {
      this.loading = true;

      await this.updateProgramacionEvaluacion({
        fk_idExpediente: this.programacion.fk_idExpediente,
        idProgramacionEvaluacion: this.programacion.idProgramacionEvaluacion,
        fk_idSolicitud: this.programacion.fk_idSolicitud,
        fk_idCatTipoExpediente: this.programacion.fk_idCatTipoExpediente,
        folio: this.programacion.folio,
        fk_idCatMotivoEvaluacion: this.programacion.fk_idCatMotivoEvaluacion,
        fechaEvaluacionMedica: this.nuevaFechaEvaluacionMedica
          ? moment(this.nuevaFechaEvaluacionMedica).format('YYYY-MM-DD HH:mm:ss')
          : this.programacion.fechaEvaluacionMedica,
        fechaEvaluacionToxicologica: this.nuevaFechaEvaluacionToxicologica
          ? moment(this.nuevaFechaEvaluacionToxicologica).format('YYYY-MM-DD HH:mm:ss')
          : this.programacion.fechaEvaluacionToxicologica,
        fechaEvaluacionPsicologica: this.nuevaFechaEvaluacionPsicologica
          ? moment(this.nuevaFechaEvaluacionPsicologica).format('YYYY-MM-DD HH:mm:ss')
          : this.programacion.fechaEvaluacionPsicologica,
        fechaRegistroSite: this.nuevaFechaEvaluacionSite
          ? moment(this.nuevaFechaEvaluacionSite).format('YYYY-MM-DD HH:mm:ss')
          : this.programacion.fechaRegistroSite,
        fechaEntrevistaIse: this.nuevaFechaEvaluacionIse
          ? moment(this.nuevaFechaEvaluacionIse).format('YYYY-MM-DD HH:mm:ss')
          : this.programacion.fechaEntrevistaIse,
        fechaEvaluacionPoligrafica: this.nuevaFechaEvaluacionPoligrafica
          ? moment(this.nuevaFechaEvaluacionPoligrafica).format('YYYY-MM-DD HH:mm:ss')
          : this.programacion.fechaEvaluacionPoligrafica,
        fk_idCatEstatusProgramacion: this.programacion.fk_idCatEstatusProgramacion,
        oficioSolicitud: this.programacion.oficioSolicitud,
        oficioProgramacion: this.programacion.oficioProgramacion,
      });

      this.SET_SNACKBAR_MESSAGE('Programación actualizada.');

      await this.fetchProgramacionesEvaluaciones();
      this.closeDialog();
    },

    getIdDerivacionByArea(idArea) {
      return this.derivaciones.find(
        (derivacion) => derivacion.fk_idEquipoApplication === idArea,
      ).idDerivacion;
    },
  },
};
</script>
